import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function OpacityIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="4 4 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 4H4V20H10V4Z" fill="#29333D" />
        <path opacity="0.7" d="M16 4H13V20H16V4Z" fill="#668098" />
        <path opacity="0.4" d="M20 4H19V20H20V4Z" fill="#668098" />
      </svg>
    </Icon>
  );
}
